import { makeStyles } from '@material-ui/core/styles';
import { ChevronRight } from '@material-ui/icons';
import { createElement } from 'react';
import { TextColors, TextOpacities, SecondaryColors } from '@/utils/constants';
import { encodeSvg, hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: { color: hexToRGBA(TextColors.light, TextOpacities.dark2) },
  closeIcon: {
    '&.MuiIconButton-root': {
      color: hexToRGBA(TextColors.light, TextOpacities.dark1),
    },
  },
  cta: {
    '&:hover, &:not(:hover)': {
      color: SecondaryColors.main,
    },
  },
  rtc: {
    '& a[href]': {
      '&:after': {
        backgroundImage: `url(${encodeSvg(
          createElement(ChevronRight, {
            xmlns: 'http://www.w3.org/2000/svg',
            fill: SecondaryColors.main,
          }),
        )})`,
      },

      '&:hover, &:not(:hover)': {
        color: SecondaryColors.main,
      },
    },
  },
};

const lightTheme = {
  root: { color: hexToRGBA(TextColors.dark, TextOpacities.light2) },
  closeIcon: {
    '&.MuiIconButton-root': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light1),
    },
  },
  cta: {
    '&:hover, &:not(:hover)': {
      color: TextColors.dark,
    },
  },
  rtc: {
    '& a[href]': {
      '&:after': {
        backgroundImage: `url(${encodeSvg(
          createElement(ChevronRight, {
            xmlns: 'http://www.w3.org/2000/svg',
            fill: TextColors.dark,
          }),
        )})`,
      },

      '&:hover, &:not(:hover)': {
        color: TextColors.dark,
      },
    },
  },
};

const useStyles = makeStyles(
  ({ breakpoints, transitions, typography }) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      '&.bg-color-blue': {
        backgroundColor: `${SecondaryColors.main} !important`,
      },
      overflow: 'hidden',
      position: 'relative',
      width: '100%',
      display: 'flex',
      transition: transitions.create('margin-top', {
        duration: transitions.duration.shortest,
        easing: transitions.easing.easeOut,
      }),

      [breakpoints.up('md')]: {
        justifyContent: 'center',
        alignItems: 'center',
        placeSelf: 'flex-start',
      },
    },

    container: {
      position: 'static',
    },

    arrow: {
      position: 'relative',
      top: '1px',
    },

    closeIcon: {
      '&.dark-theme': darkTheme.closeIcon,
      '&.light-theme': lightTheme.closeIcon,

      '&.MuiIconButton-root': {
        top: '50%',
        transform: 'translateY(-50%)',
        position: 'absolute',
        right: '25px',
        zIndex: 2,
      },
    },

    columnContent: {
      paddingTop: '11.5px',
      paddingBottom: '11.5px',

      [breakpoints.up('md')]: {
        '& + *': {
          marginLeft: '8px',
        },
      },

      [breakpoints.down('sm')]: {
        '& + *': {
          marginTop: '8px',
        },
        alignItems: 'center',
      },
    },

    columnCta: {
      position: 'relative',
      zIndex: 1,

      [breakpoints.down('sm')]: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
    },

    cta: {
      '&.dark-theme': darkTheme.cta,
      '&.light-theme': lightTheme.cta,
      ...typography.body2,
      fontWeight: 500,

      '& .MuiSvgIcon-root:last-child': {
        marginLeft: 0,
      },
    },

    innerContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',

      [breakpoints.up('md')]: {
        width: 'auto',
        alignItems: 'baseline',
        justifyContent: 'center',
        flexDirection: 'row',
      },
    },

    rtc: {
      '&.dark-theme': darkTheme.rtc,
      '&.light-theme': lightTheme.rtc,
      '&.is-collapsible': {
        padding: '0 27px',
      },

      [breakpoints.down('sm')]: {
        textAlign: 'center',
      },

      '& + *': {
        marginTop: '.5em',
      },

      '& a[href], a[href]:not(:hover), h1, h2, h3, h4, h5, h6, p': {
        ...typography.body2,
        textDecoration: 'none',
        marginBottom: 0,
        fontWeight: 500,
      },

      '& a[href]': {
        transition: 'color 150ms ease-out',

        '&:after': {
          content: '""',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          display: 'inline-block',
          marginLeft: '2px',
          marginRight: '-4px',
          marginTop: '-2px',
          height: '18px',
          verticalAlign: 'middle',
          width: '18px',
        },
      },
    },
  }),
  { name: 'GenSimpleRibbon' },
);

export default useStyles;
